export const billableAddons = [
  {
    name: 'signPostSpeedData',
    displayName: 'SETTINGS.SIGN_POST_SPEED_DATA',
  },
  {
    name: 'snapToRoads',
    displayName: 'SETTINGS.ADVANCED_SIGN_POST_SPEED_DATA',
  },
]
